import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
// import * as userActions from "./user.actions";
import * as subscriptionActions from "./subscription.actions";
import { ISubscriptionPlanInfo } from "../../models/Subscription";
import { IResponse } from "../../models/admin";

export interface ISubscriptionState {
    Subscriptions: ISubscriptionPlanInfo[];
}

export const initialState: ISubscriptionState = {
    Subscriptions: []
}

export const subscriptionReducer = createReducer<ISubscriptionState>(
    initialState,
    on(subscriptionActions.FetchSubscriptionsSuccessAction, (state: ISubscriptionState, props: { response: IResponse<ISubscriptionPlanInfo[]> }) => {
        return {
            ...state,
            Subscriptions: props.response.Value
        }
    })
);
